import { startAPIServer } from './index.js'

await startAPIServer()
